<template>
    <div class="c-app flex-row align-items-center">
      <CContainer style="display: flex; justify-content: center" class="p-0">
        <div class="container-box center">
          <div class="text-left">
            <div class="card-custom-web">
              <br />
  
              <div class="list-grade">
                <div v-for="item in teacher.academicProfileList" v-bind:key="item.Id">
                  <label class="ml-3">Tell us a little bit about your academic profile</label>
                  <br />
                  <form class="ml-3 mr-3">
                    <textarea
                      type="text"
                      class="custom-textarea"
                      placeholder="About me"
                      v-model="item.name">
                    </textarea>
                  </form>
  
                  <div class="bottom-center">
                    <CButton color="primary" class="btn-select-blue mt-5" @click="submitSave(item.name)"> Save</CButton>
                  </div>
  
                </div>
                <div style="clear: both"></div>
              </div>
  
            </div>
          </div>
        </div>
      </CContainer>
      
      <div class="header-top">Academic Profile</div>
      <div class="header-left">
        <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
      </div>
      <div style="clear: both"></div>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import _ from "lodash";
  import VuejsDialog from "vuejs-dialog";
  Vue.use(VuejsDialog);
  
  export default {
    data() {
      return {
        user: {},
        teacher: {},
        insertSuccess: false,
      };
    },
  
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetInfoUser();
      } else {
        this.GoToLogin();
      }
    },
  
    methods: {
      GetInfoUser() {
        return this.$API
          .get(this.$LoginUserDetailWebs, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.user = response.data;
              this.GetTeacherProfile(this.user.id);
            }
          });
      },
  
      GetTeacherProfile() {
        return this.$API
          .get(this.$TeacherProfile + "?userId=" + this.user.id, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.teacher = response.data;
            }
          });
      },
  
      submitSave: function (name) {
        const formData = new FormData();
  
        formData.append("userId", this.user.id);
        formData.append("content", name);
        
        return this.$API
          .post(this.$InsertUpdateAcademiceProfile, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if(response.status == 200 && response.data != null) {
              this.GoToTutorDetail();
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.status);
            }
          });
      },
  
      GoBack() {
        this.$router.back();
      },
  
      GoToTutorDetail()
      {
        this.$router.push("/Tutor/TutorDetail");
      }
    },
  };
  </script>
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  
  input {
    border-bottom: 2px solid #dbdbdb;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    width: 90%;
  }
  
  input ::placeholder {
    color: #e0e0e0;
  }
  
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #e0e0e0;
  }
  .c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  }
  .custom-bg-color {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    /* Clickable/Light */
  
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin: 0px 20px;
    display: flex;
    justify-content: center;
  }
  body {
    font-family: "Montserrat", sans-serif;
  }
  .custom-textarea {
    width: 100%;
    height: 200px;
    padding: 10px 10px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    font-size: 12px;
    resize: none;
  }
  </style>